import { render, staticRenderFns } from "./provider-form.vue?vue&type=template&id=5fbf24a5"
import script from "./provider-form.vue?vue&type=script&lang=js"
export * from "./provider-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports